$(function() {

        $('body.home .block-a-la-une').slick({
            centerMode: true,
            centerPadding: '0px',
            slidesToShow: 3,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {slidesToShow: 2, arrows: true}
                },
                {
                    breakpoint: 768,
                    settings: {slidesToShow: 1, arrows: false, dots: true }
                }
            ]
        });

    $('body.home .block-accueil-guides-et-documentations-slider').slick({
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 4,
        swipeToSlide: true,
        responsive: [
            {
                breakpoint: 1410,
                settings: {slidesToShow: 3}
            },
            {
                breakpoint: 960,
                settings: {slidesToShow: 2, arrows: true}
            },
            {
                breakpoint: 768,
                settings: {slidesToShow: 1, arrows: false, dots: true }
            }
        ]
    });

});
